import PdfPreview from './pdfPreview';

export default PdfPreview;
